import { ReactNode } from 'react'

import { IntegrationType } from '../types'
import { RequestRevisionTab } from './RequestRevisionTab'

export interface VendorExtraTabContext {
  appraisalID: number
  status: string | null
  data: Record<string, any>
}

export interface VendorExtraTab {
  label: string
  render: (ctx: VendorExtraTabContext) => ReactNode
}

export const vendorExtraTabs: Partial<Record<IntegrationType, VendorExtraTab[]>> = {
  [IntegrationType.ClassValuation]: [
    {
      label: 'Request Revision',
      render: ({ appraisalID, status }) => <RequestRevisionTab appraisalID={appraisalID} status={status} />,
    },
  ],
}

export const getVendorExtraTabs = (integrationType: IntegrationType): VendorExtraTab[] =>
  vendorExtraTabs[integrationType] ?? []
